document.addEventListener('DOMContentLoaded', () => {
  const userAgent = window.navigator.userAgent.toLocaleLowerCase();
  if(userAgent.indexOf('chrome') === -1) {
    const chromeRecommendedBanner = document.querySelector<HTMLElement>('.ChromeRecommendedBanner');
    chromeRecommendedBanner?.classList.add('show');
  }
});
